import classnames from "classnames";
import Translate from "lang/Translate";

export interface BaseButtonProps {
    fieldId: string,
    tabIndex?: number,
    labelKey: string,
    isEnabled?: boolean,
    onClick?: () => void,
    buttonStyles?: string,
    loading?: boolean,
    autofocus?: boolean,
    onBlur?: () => void
};

const BaseButton = ({ labelKey, buttonStyles, isEnabled, onClick = () => {}, loading, fieldId, tabIndex, autofocus, onBlur = () => {} }: BaseButtonProps) => {
    return (
        <button
            data-testid="base-button"
            className={classnames("button shadow-btn", buttonStyles, { "is-loading": Boolean(loading) })}
            id={fieldId}
            tabIndex={tabIndex}
            autoFocus={autofocus}
            onBlur={onBlur}
            onClick={onClick}
            disabled={isEnabled === false}
        >
            <Translate text={labelKey} />
        </button>
    );
};

export default BaseButton;
